var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"cost_center.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"costCenter.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"cost_center.create\">\n<a translate=\"costCenter.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="cost_center.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_control/component/cost_center/cost_center.html
// module id = 2831
// module chunks = 1